if(typeof BSS_B2B != 'undefined'){
  let debounceTimeout;

  function debounce(func, delay) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(func, delay);
  }
  
  function handleCheckout(){
    const style = document.getElementById('checkout-style');
      // console.log("style ", style)
      if (!style) {
      const styleId = 'checkout-style';
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .cart__checkout-button {
          opacity: 0.6;
          pointer-events: none;
        }
      `;
      document.body.appendChild(style);
      }
  }
  
  function removeStyleCheckout(){
    const style = document.getElementById('checkout-style');
    // console.log("styleRmv ", style)
      if (style) {
        style.parentNode.removeChild(style);
      }  
  }
  
  document.addEventListener("bss_b2b_cart_fixer_done", (e) => {
    // console.log("fixer")
    debounce(removeStyleCheckout, 600);
  });
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for(const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const targetElement = mutation.target;
        if (targetElement.classList.contains('active')) {
          handleCheckout();
          setTimeout(() => {
            removeStyleCheckout();
          }, 5000)
        }
      }
    }
  });
  
  const targetElement = document.querySelector('.block_Wholesale_cart');
  const config = { attributes: true, attributeFilter: ['class'] };
  targetElement && observer.observe(targetElement, config);

  
  setTimeout(() => {
    const draw = document.querySelector("#CartDrawer");
    if(draw){
      const observer = new MutationObserver((MutationList) => {
          for(let item of MutationList){
              if(item.target.className.includes('drawer__inner') || item.target.className.includes('drawer-you-may-like')){
                console.log(123)
                handleCheckout();
                setTimeout(() => {
                removeStyleCheckout();
              }, 5000)
                setTimeout(() => {
                  const a = document.querySelectorAll('.splide__list [role="group"]');
                  a.forEach(element => {
                    const classList = element.classList;
                  
                      // Find the class that starts with 'product-id-'
                      const productIdClass = Array.from(classList).find(className => className.startsWith('product-id-'));
                  
                      // Extract the product ID
                      const productId = productIdClass.split('-')[2];
                      const price = element.querySelector(".rebuy-product-price");
                      if(price && productId){
                          price.setAttribute('bss-b2b-product-id', productId);
                          price.setAttribute('bss-b2b-product-price', '');
                      }
                  })
                  BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,false, false);
                  BSS_B2B.cart.fixer(BSS_B2B.shopData,false, false);
                }, 1000)
                
              }
          }
      })
      observer.observe(draw, {subtree: true, childList: true})
    }
  }, 300)
}

